// src/ThemeProviderWrapper.jsx
import React, { useEffect } from "react";
import { ThemeProvider } from "./theming";

const ThemeProviderWrapper = ({ children, theme }) => {
  console.log("ThemeProviderWrapper - Received theme:", theme);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--color-accent", theme.accentColor || "#1E40AF");
    root.style.setProperty(
      "--color-background",
      theme.backgroundColor || "#F1F5F9"
    );
    root.style.setProperty(
      "--color-text-primary",
      theme.textColor || "#1F2937"
    );
    root.style.setProperty(
      "--color-text-secondary",
      theme.secondaryColor || "#4B5563"
    );
    root.style.setProperty("--color-charcoal", theme.charcoal || "#333333");
    root.style.setProperty(
      "--font-family-sans",
      theme.fontSans || "Inter, sans-serif"
    );
    root.style.setProperty(
      "--font-family-serif",
      theme.fontSerif || "Georgia, serif"
    );

    // Update TailwindCSS custom properties
    root.style.setProperty("--tw-color-accent", theme.accentColor || "#1E40AF");
    root.style.setProperty(
      "--tw-color-background",
      theme.backgroundColor || "#F1F5F9"
    );
    root.style.setProperty(
      "--tw-color-text-primary",
      theme.textColor || "#1F2937"
    );
    root.style.setProperty(
      "--tw-color-text-secondary",
      theme.secondaryColor || "#4B5563"
    );
    root.style.setProperty("--tw-color-charcoal", theme.charcoal || "#333333");

    console.log("ThemeProviderWrapper - CSS variables applied:", theme);
  }, [theme]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeProviderWrapper;
